var _path, _path2, _path3, _g, _g2, _g3, _g4, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g7, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWaimakariri = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1200,
    viewBox: "0 0 1600 1200",
    width: 1600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m388.249 1000.56c176.598 161.73 428.171 126.23 607.925-63.022 179.756-189.255 143.706-485.363-64.752-607.743-208.461-122.381-438.327-118.03-607.925 63.02-169.597 181.05-111.846 446.015 64.752 607.745z",
    fill: "#eff3f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1398.29 150.015c95.29 52.231 213.23 56.872 283.09-29.398 69.86-86.2703 56.38-212.9802-30.1-283.014-86.49-70.035-206.76-36.837-283.09 29.398-76.33 66.2353-65.19 230.7834 30.1 283.014z",
    fill: "#eff3f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1750.34 737.054c118.55 96.002 118.64 253.55 40.86 388.446-77.77 134.89-209.78 259.06-301.87 372.78s-262.31 142.94-388.45 40.79c-126.15-102.15-145.81-284.75-40.87-388.44 104.94-103.7 189.61-260.051 301.87-372.787 112.27-112.736 269.9-136.791 388.46-40.789z",
    fill: "#eff3f0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m162.944 394.698c94.533 76.55 222.899 59.23 296.061-31.118s61.357-239.674-31.117-296.0609c-92.474-56.387-228.671-77.8501-296.061 31.1173-67.3907 108.9676-63.4155 219.5106 31.117 296.0616z",
    fill: "#2e933c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.944 394.698c94.533 76.55 222.899 59.23 296.061-31.118s61.357-239.674-31.117-296.0609c-92.474-56.387-228.671-77.8501-296.061 31.1173-67.3907 108.9676-63.4155 219.5106 31.117 296.0616z",
    fill: "#000",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m453.019 1085.22c29.983 24.28 70.706 18.77 93.922-9.9s19.482-76.041-9.85-93.924c-29.331-17.883-72.535-24.682-93.922 9.894-21.386 34.58-20.133 69.65 9.85 93.93z",
    fill: "#2e933c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.019 1085.22c29.983 24.28 70.706 18.77 93.922-9.9s19.482-76.041-9.85-93.924c-29.331-17.883-72.535-24.682-93.922 9.894-21.386 34.58-20.133 69.65 9.85 93.93z",
    fill: "#000",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.4301 113.292c19.6902 15.944 46.4337 12.329 61.6799-6.498 15.246-18.8278 12.794-49.9395-6.468-61.6833-19.2626-11.7439-47.6354-16.2091-61.6802 6.4977-14.0448 22.7067-13.222 45.7383 6.4683 61.6836z",
    fill: "#2e933c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.4301 113.292c19.6902 15.944 46.4337 12.329 61.6799-6.498 15.246-18.8278 12.794-49.9395-6.468-61.6833-19.2626-11.7439-47.6354-16.2091-61.6802 6.4977-14.0448 22.7067-13.222 45.7383 6.4683 61.6836z",
    fill: "#000",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m587.076 995.936c-11.369 4.254-15.555 16.434-11.144 28.904 4.411 12.48 18.615 17.66 28.939 11.07 10.325-6.6 15.419-17.09 11.144-28.91-4.274-11.829-17.57-15.319-28.939-11.064z",
    fill: "#2e933c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m587.076 995.936c-11.369 4.254-15.555 16.434-11.144 28.904 4.411 12.48 18.615 17.66 28.939 11.07 10.325-6.6 15.419-17.09 11.144-28.91-4.274-11.829-17.57-15.319-28.939-11.064z",
    fill: "#000",
    fillOpacity: 0.2
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1247.45 205.509c49.67 40.225 117.14 31.105 155.6-16.392s32.28-125.9834-16.32-155.6098c-48.59-29.62641-120.17-40.89098-155.6 16.392-35.43 57.2828-33.35 115.3848 16.32 155.6098z",
    fill: "#cbe4ce",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m511.43 397.292c19.69 15.944 46.434 12.329 61.68-6.498 15.246-18.828 12.794-49.94-6.468-61.683-19.263-11.744-47.635-16.209-61.68 6.497-14.045 22.707-13.222 45.739 6.468 61.684z",
    fill: "#cbe4ce",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m599.468 401.587c8.95 7.248 21.106 5.605 28.037-2.953 6.93-8.558 5.815-22.7-2.941-28.038-8.755-5.338-21.652-7.368-28.036 2.953-6.384 10.322-6.01 20.79 2.94 28.038z",
    fill: "#cbe4ce",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m926.311 1259.89c32.543 26.36 91.909-6.61 128.409-42.34 36.51-35.73 31.37-99.5-13.86-129.45-45.225-29.95-97.565-26.08-129.5 13.36-31.934 39.43-17.592 132.08 14.951 158.43z",
    fill: "#2e933c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m926.311 1259.89c32.543 26.36 91.909-6.61 128.409-42.34 36.51-35.73 31.37-99.5-13.86-129.45-45.225-29.95-97.565-26.08-129.5 13.36-31.934 39.43-17.592 132.08 14.951 158.43z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m347.762 826.256c72.02 65.956 174.618 51.48 247.926-25.703 73.309-77.183 58.61-197.943-26.405-247.853-85.016-49.909-178.761-48.134-247.927 25.703-69.167 73.837-45.615 181.897 26.406 247.853z",
    fill: "#2e933c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m347.762 826.256c72.02 65.956 174.618 51.48 247.926-25.703 73.309-77.183 58.61-197.943-26.405-247.853-85.016-49.909-178.761-48.134-247.927 25.703-69.167 73.837-45.615 181.897 26.406 247.853z",
    fill: "#000",
    fillOpacity: 0.2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1420.89 782.958c27.27 24.967 66.1 19.487 93.85-9.729 27.75-29.217 22.19-74.93-9.99-93.822-32.18-18.893-67.67-18.222-93.85 9.728-26.18 27.951-17.27 68.855 9.99 93.823z",
    fill: "#2e933c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1420.89 782.958c27.27 24.967 66.1 19.487 93.85-9.729 27.75-29.217 22.19-74.93-9.99-93.822-32.18-18.893-67.67-18.222-93.85 9.728-26.18 27.951-17.27 68.855 9.99 93.823z",
    fill: "#000",
    fillOpacity: 0.2
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m575.174 873.061c8.952 8.198 21.705 6.399 30.817-3.195s7.284-24.604-3.283-30.807c-10.567-6.204-22.219-5.983-30.816 3.194-8.597 9.178-5.67 22.609 3.282 30.808z",
    fill: "#2e933c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m575.174 873.061c8.952 8.198 21.705 6.399 30.817-3.195s7.284-24.604-3.283-30.807c-10.567-6.204-22.219-5.983-30.816 3.194-8.597 9.178-5.67 22.609 3.282 30.808z",
    fill: "#000",
    fillOpacity: 0.2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1490.17 842.061c8.96 8.198 21.71 6.399 30.82-3.195s7.29-24.604-3.28-30.807c-10.57-6.204-22.22-5.983-30.82 3.194-8.6 9.178-5.67 22.609 3.28 30.808z",
    fill: "#2e933c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1490.17 842.061c8.96 8.198 21.71 6.399 30.82-3.195s7.29-24.604-3.28-30.807c-10.57-6.204-22.22-5.983-30.82 3.194-8.6 9.178-5.67 22.609 3.28 30.808z",
    fill: "#000",
    fillOpacity: 0.2
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m609.087 818.53c4.476 4.099 10.852 3.2 15.408-1.597s3.643-12.302-1.641-15.404c-5.283-3.101-11.109-2.991-15.408 1.598s-2.835 11.304 1.641 15.403z",
    fill: "#2e933c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m609.087 818.53c4.476 4.099 10.852 3.2 15.408-1.597s3.643-12.302-1.641-15.404c-5.283-3.101-11.109-2.991-15.408 1.598s-2.835 11.304 1.641 15.403z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m874.894 559.958c27.263 24.967 66.1 19.487 93.85-9.729 27.75-29.217 22.186-74.93-9.996-93.822-32.182-18.893-67.668-18.222-93.85 9.728-26.182 27.951-17.267 68.855 9.996 93.823z",
    fill: "#2e933c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m874.894 559.958c27.263 24.967 66.1 19.487 93.85-9.729 27.75-29.217 22.186-74.93-9.996-93.822-32.182-18.893-67.668-18.222-93.85 9.728-26.182 27.951-17.267 68.855 9.996 93.823z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m127.174 496.061c8.952 8.198 21.705 6.399 30.817-3.195s7.284-24.604-3.283-30.807c-10.567-6.204-22.219-5.983-30.816 3.194-8.597 9.178-5.67 22.609 3.282 30.808z",
    fill: "#2e933c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m127.174 496.061c8.952 8.198 21.705 6.399 30.817-3.195s7.284-24.604-3.283-30.807c-10.567-6.204-22.219-5.983-30.816 3.194-8.597 9.178-5.67 22.609 3.282 30.808z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m1383.17 999.061c8.96 8.199 21.71 6.399 30.82-3.195s7.29-24.604-3.28-30.807c-10.57-6.204-22.22-5.983-30.82 3.194-8.6 9.178-5.67 22.609 3.28 30.808z",
    fill: "#2e933c"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m1383.17 999.061c8.96 8.199 21.71 6.399 30.82-3.195s7.29-24.604-3.28-30.807c-10.57-6.204-22.22-5.983-30.82 3.194-8.6 9.178-5.67 22.609 3.28 30.808z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m859.437 592.024c-6.157 10.46-1.746 22.56 9.532 29.478 11.279 6.919 25.581 2.011 29.452-9.615s1.233-22.978-9.532-29.479c-10.764-6.501-23.294-.845-29.452 9.616z",
    fill: "#2e933c"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m859.437 592.024c-6.157 10.46-1.746 22.56 9.532 29.478 11.279 6.919 25.581 2.011 29.452-9.615s1.233-22.978-9.532-29.479c-10.764-6.501-23.294-.845-29.452 9.616z",
    fill: "#000",
    fillOpacity: 0.2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#cbe4ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1541.89 382.958c27.27 24.967 66.1 19.487 93.85-9.73 27.75-29.216 22.19-74.929-9.99-93.821-32.18-18.893-67.67-18.222-93.85 9.728-26.18 27.951-17.27 68.855 9.99 93.823z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-63.1326 1353.31c106.6633 86.38 276.9216 66.4 385.7606-40.19 108.838-106.58 93.73-296.58-40.893-385.685-134.623-89.101-290.52784-77.413-385.76 40.19-95.233 117.605-65.771 299.315 40.8924 385.685z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1490.94 370.49c86.48 70.034 86.54 184.98 29.79 283.403s-153.07 189.023-220.27 272.001c-67.19 82.976-191.37 104.306-283.4 29.787-92.023-74.52-106.353-207.743-29.785-283.403 76.565-75.66 138.345-189.742 220.265-272.001 81.91-82.26 196.91-99.821 283.4-29.787z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1056.63 348.682c36.82 33.724 89.28 26.323 126.76-13.142 37.49-39.464 29.97-101.21-13.5-126.73-43.47-25.519-91.4-24.612-126.77 13.142-35.36 37.753-23.32 93.005 13.51 126.73z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-220.855 1017.32c100.914 92.42 244.6694 72.13 347.386-36.011 102.717-108.146 82.12-277.35-37.0009-347.282-119.1206-69.931-250.4731-67.445-347.3861 36.012s-63.912 254.866 37.001 347.281z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1510.15 1402.32c100.91 92.42 244.66 72.13 347.38-36.01 102.72-108.15 82.12-277.35-37-347.28-119.12-69.934-250.47-67.448-347.39 36.01-96.91 103.46-63.91 254.86 37.01 347.28z",
    opacity: 0.2
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m1437.56 250.478c15.54 8.51 34.78 9.25 46.19-4.842 11.41-14.091 9.23-34.77-4.87-46.188-14.1-11.417-33.72-5.98-46.19 4.842-12.46 10.822-10.67 37.678 4.87 46.188z",
    fill: "#eff3f0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m1164.69 76.1571c9.42 5.1578 21.08 5.6059 28-2.9344 6.91-8.5402 5.59-21.073-2.95-27.9926-8.55-6.9197-20.45-3.6247-28 2.9343s-6.47 22.8349 2.95 27.9927z",
    fill: "#eff3f0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m1074.92-252.316c86.49 70.034 99.83 196.9175 29.79 283.4025-70.03 86.4845-162.49 180.0035-220.26 272.0015-57.771 91.997-205.427 110.272-283.403 29.786-77.977-80.485-107.887-186.957-29.787-283.4025 78.1-96.445 143.519-177.2315 220.262-272.0015 76.743-94.769 196.918-99.821 283.398-29.786z",
    fill: "#2e933c"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m1074.92-252.316c86.49 70.034 99.83 196.9175 29.79 283.4025-70.03 86.4845-162.49 180.0035-220.26 272.0015-57.771 91.997-205.427 110.272-283.403 29.786-77.977-80.485-107.887-186.957-29.787-283.4025 78.1-96.445 143.519-177.2315 220.262-272.0015 76.743-94.769 196.918-99.821 283.398-29.786z",
    fill: "#000",
    fillOpacity: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWaimakariri);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/waimakariri.7c9faa9c6720604b4b7bf6923304a98d.svg";